import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

const entity = 'Employee/Select';

export function CasRHFEmployeeSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect(entity, props);
}

export function CasEmployeeSelect(props: componentProps) {
  return CasEntitySelect(entity, props);
}
